__turbopack_context__.v({
  "root": "Video-module__I4UnJa__root",
});
